import * as C from './common/constants';
import * as ROUTES from './common/routes';
import Article from './components/Article';
import Home from './components/Home';
import Layout from './components/Layout';
import MapContainer from './components/MapContainer';
import NotFound from './components/NotFound';
import React from 'react';
import SurveyAdd from './components/SurveyAdd';
import SearchResults from './components/SearchResults';
import SurveyAnswers from './components/SurveyAnswers';
import ThemeSurveys from './components/ThemeSurveys';
import configureStore from './common/redux/configureStore';
import { EIDs } from './common/enums';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './common/theme';
import How from './components/How';
import {
  HashRouter as Router,
  Route,
  Routes,
  useParams,
  useLocation,
} from 'react-router-dom';

const store: Store = configureStore();

const App = () => {
  const ThemeSurveysWrapper = () => {
    const params = useParams();

    return <ThemeSurveys key={params?.themeId} />;
  };

  const SearchWrapper = () => {
    const { search } = useLocation();

    return <SearchResults key={search} />;
  };

  const ThemeSurveyWrapper = () => {
    const { pathname } = useLocation();

    return <SurveyAnswers key={pathname} />;
  };

  const SurveyAddWrapper = () => {
    const { pathname } = useLocation();
    const randomNumber = Math.random();

    return <SurveyAdd key={pathname + randomNumber} />;
  };

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Router>
          <Layout>
            <Routes>
              <Route path={ROUTES.ROOT} element={<Home />} />
              <Route
                path={`${ROUTES.THEME}/:themeId/:surveyId/:answerId`}
                element={<ThemeSurveyWrapper />}
              />
              <Route
                path={`${ROUTES.PDF}/:themeId/:surveyId/:answerId`}
                element={<ThemeSurveyWrapper />}
              />
              <Route
                path={`${ROUTES.THEME}/:themeId/:surveyId`}
                element={<ThemeSurveys />}
              />
              <Route
                path={`${ROUTES.THEME}/:themeId`}
                element={<ThemeSurveysWrapper />}
              />
              <Route
                path={`${ROUTES.ADD}/:themeId/:surveyId`}
                element={<SurveyAddWrapper />}
              />
              <Route
                path={ROUTES.ABOUT}
                element={<Article type={EIDs.ABOUT} key={EIDs.ABOUT} />}
              />
              <Route
                path={ROUTES.EXPEDITION}
                element={
                  <Article type={EIDs.EXPEDITION} key={EIDs.EXPEDITION} />
                }
              />
              <Route
                path={ROUTES.PRIVACY}
                element={<Article type={EIDs.PRIVACY} key={EIDs.PRIVACY} />}
              />
              <Route path={ROUTES.SEARCH} element={<SearchWrapper />} />
              <Route path={ROUTES.MAP} element={<MapContainer />} />
              <Route path={ROUTES.HOW} element={<How type={EIDs.HOW} />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </Router>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
